import React, { useState, useEffect } from 'react';
import { Container, Alert, Nav } from 'react-bootstrap';
import './AdminPanel.css';

import { useNavigate } from 'react-router-dom';
import API from '../api';
import UserManagement from './admin/UserManagement';
import SystemNotifications from './admin/SystemNotifications';
import ActivityLogs from './admin/ActivityLogs';

function AdminPanel() {
    const [loading, setLoading] = useState(true);
    const [authorized, setAuthorized] = useState(false);
    const [message, setMessage] = useState(null);
    const [activeTab, setActiveTab] = useState('users');
    const [users, setUsers] = useState([]);
    const [currentSystemMessage, setCurrentSystemMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(API.CHECK_ADMIN, { method: 'GET', credentials: 'include' })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'success') {
                setAuthorized(true);
                fetchUsers();
                fetchSystemMessage();
            } else { navigate('/401'); }
            setLoading(false);
        })
        .catch(() => { setLoading(false); navigate('/401'); });
    }, [navigate]);

    const fetchUsers = () => {
        fetch(API.USERS, { method: 'GET', credentials: 'include' })
        .then(response => response.json())
        .then(data => setUsers(data.users || []))
        .catch(error => console.error('Error fetching users:', error));
    };

    const fetchSystemMessage = () => {
        fetch(API.NOTIFICATIONS, { method: 'GET', credentials: 'include' })
        .then(response => response.json())
        .then(data => {
            if (data.notifications && data.notifications.length > 0) {
                setCurrentSystemMessage(data.notifications[0].message);
            }
        })
        .catch(error => console.error('Error fetching system notifications:', error));
    };

    if (loading && !authorized) return <div className="loading-spinner"></div>;
    if (!authorized) return null;

    return (
        <Container fluid className="admin-panel-container mt-5">
            <h2 className="admin-panel-title">Admin Control Panel</h2>
            {message && <Alert variant="info" dismissible onClose={() => setMessage(null)}>{message}</Alert>}

            <Nav variant="tabs" className="admin-panel-tabs mb-4" activeKey={activeTab} onSelect={(tab) => setActiveTab(tab)}>
                <Nav.Item><Nav.Link eventKey="users" className="admin-panel-tab">User Management</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link eventKey="notifications" className="admin-panel-tab">System Notifications</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link eventKey="logs" className="admin-panel-tab">Activity Logs</Nav.Link></Nav.Item>
            </Nav>

            <div className="admin-panel-content">
                {activeTab === 'users' && <UserManagement users={users} fetchUsers={fetchUsers} setMessage={setMessage} />}
                {activeTab === 'notifications' && <SystemNotifications currentSystemMessage={currentSystemMessage} setCurrentSystemMessage={setCurrentSystemMessage} setMessage={setMessage} />}
                {activeTab === 'logs' && <ActivityLogs />}
            </div>
        </Container>
    );
}

export default AdminPanel;
